(function () {
    'use strict';

    angular
        .module('physicalFairs')
        .controller('PhysicalFairTranslatorController', PhysicalFairTranslatorController);
    PhysicalFairTranslatorController.$inject = ['ExpoService', 'PhysicalFairService', 'CitiesByExpoService'];
    function PhysicalFairTranslatorController(ExpoService, PhysicalFairService, CitiesByExpoService) {
        var vm = this;

        vm.flag                  = false;
        vm.expoSelected          = '';
        vm.citySelected          = '';
        vm.selectExpo            = selectExpo;
        vm.selectCitiesByExpo    = selectCitiesByExpo;
        vm.getByFilter           = getByFilter;
        vm.city;

        /* PAGINATION */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        vm.page         = 1;

        function setPage(page) {
            vm.currentPage = page;
        }

        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getByFilter(false);
        }

        function activate() {
            vm.selectExpo();
        }

        function selectExpo () {
            ExpoService.getExpos().then(function(response){
                 vm.expos = response.data;
            }).catch(function(err) {
            });
        }

        function getByFilter() {

            vm.queryFlag = false;
            vm.query = {};
            vm.query['page']    = vm.page;
            if(vm.expoSelected !== '') {
                vm.query['expo_id'] = vm.expoSelected;
            }
            if(vm.citySelected !== '') {
                vm.query['city_id'] = vm.citySelected;
            }
            PhysicalFairService.getTranslators(vm.query).then(function(response){
                vm.queryFlag        = true;
                vm.exhibitors       = response.data.data;
                vm.totalItems       = response.data.total;
                vm.itemsPerPage     = response.data.per_page;
                vm.setPage(response.data.current_page);

            }).catch(function(err){
            });
        }

        function selectCitiesByExpo () {
            CitiesByExpoService.getCities(vm.expoSelected).then(function(response){
                vm.city = response.data;
            }).catch(function(err) {

            });
        }

        activate();
    }
})();